import "./responsive_namespace.js";

// This is a lookup table for device width sizes

window.Sparkle ??= {};
window.Sparkle.Responsive ??= {};

Sparkle.Responsive.Entities = {
  smMobile: 375,
  mobile: 500,
  lgMobile: 750,
  tablet: 1024,
  laptop: 1366,
  desktop: 1500,
  tv: 3840,
};
